import styled from "styled-components";
import { textAlign, variant } from "styled-system";
import { apolloSpaceInset1X, apolloSpaceInset2X, apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
import Flex from "../box/Flex";
import { KEBAB_WITH_PADDING_WIDTH } from "./KebabWithPortal.style";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { getTableColumnWidthProps, hasTags } from "./TableColumn";
import { getJustifyContentFromTextAlign } from "./utils";
import { HiddenButtonIcon } from "../menu/KebabActionMenu.style";
const GLOBAL_FILTER_PADDING_VERTICAL = getValueFromPixelString(apolloSpaceInsetHalfX) / 2;
const GLOBAL_FILTER_PADDING_HORIZONTAL = getValueFromPixelString(apolloSpaceInsetHalfX);
export const getCellPadding = (isInGlobalFilters) => ({
    compact: {
        paddingTop: apolloSpaceInsetHalfX,
        paddingRight: !isInGlobalFilters
            ? apolloSpaceInset1X
            : `${getValueFromPixelString(apolloSpaceInset1X) - GLOBAL_FILTER_PADDING_HORIZONTAL}px`,
        paddingBottom: apolloSpaceInsetHalfX,
        paddingLeft: apolloSpaceInset1X,
    },
    comfortable: {
        paddingTop: apolloSpaceInset2X,
        paddingRight: !isInGlobalFilters
            ? apolloSpaceInset1X
            : `${getValueFromPixelString(apolloSpaceInset1X) - GLOBAL_FILTER_PADDING_HORIZONTAL}px`,
        paddingBottom: apolloSpaceInset2X,
        paddingLeft: apolloSpaceInset1X,
    },
});
const getIsInGlobalFiltersStyle = (theme) => {
    const borderWidth = 1;
    return {
        background: theme.colors.apolloColorBackgroundFilter,
        border: `${borderWidth}px solid ${theme.colors.apolloColorStrokeFilter}`,
        borderRadius: "2px",
        marginTop: `${-1 * GLOBAL_FILTER_PADDING_VERTICAL}px`,
        marginBottom: `${-1 * GLOBAL_FILTER_PADDING_VERTICAL}px`,
        marginLeft: `${-1 * GLOBAL_FILTER_PADDING_HORIZONTAL}px`,
        padding: `${GLOBAL_FILTER_PADDING_VERTICAL - borderWidth}px ${GLOBAL_FILTER_PADDING_HORIZONTAL - borderWidth}px`,
    };
};
export const StyledTableCellContent = styled.div.withConfig({ displayName: "StyledTableCellContent_APC-7311-productShell", componentId: "sc-125ga22" })(({ theme, column, isGroupParentCell }) => (Object.assign(Object.assign({ boxSizing: "border-box", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: column.whiteSpace, minWidth: column.minWidth }, getTableColumnWidthProps(column)), (isGroupParentCell ? theme.textStyles.bodyStrong : theme.textStyles.body))), ({ isInGlobalFilters }) => variant({
    variants: getCellPadding(isInGlobalFilters),
}), ({ column }) => (Object.assign({}, (column.type === "TableSelectionColumn" && {
    padding: `calc(${apolloSpaceInsetHalfX} - 1px) calc(${apolloSpaceInset1X} - 1px) `,
}))));
export const StyledTableCell = styled.td.withConfig({ displayName: "StyledTableCell_APC-7311-productShell", componentId: "sc-qh9fkj" })(({ theme, $shouldFitContent, locked }) => (Object.assign(Object.assign(Object.assign(Object.assign({ position: "relative", boxShadow: theme.colors.apolloBoxShadowSeparatorBottom }, ($shouldFitContent && { width: "1%", whiteSpace: "nowrap" })), { "&&": { verticalAlign: "middle" } }), (locked && {
    position: "sticky",
    right: 0,
    zIndex: 1,
})), { [`&:hover ${HiddenButtonIcon}, &:focus-within ${HiddenButtonIcon}`]: {
        opacity: 1,
    } })), textAlign, () => variant({
    prop: "$type",
    variants: {
        TableFillerColumn: {
            [`& ${StyledTableCellContent}`]: {
                padding: "0 !important",
            },
        },
    },
}));
export const StyledTableCellContentGlobalFilter = styled.span.withConfig({ displayName: "StyledTableCellContentGlobalFilter_APC-7311-productShell", componentId: "sc-1mua2d7" })(({ theme }) => (Object.assign({}, getIsInGlobalFiltersStyle(theme))));
export const StyledTableCellContentWithAction = styled(StyledTableCellContent).withConfig({ displayName: "StyledTableCellContentWithAction_APC-7311-productShell", componentId: "sc-qif0op" })(({ column: { align } }) => ({
    display: "flex",
    position: "relative",
    justifyContent: getJustifyContentFromTextAlign(align),
    alignItems: "center",
    overflow: "visible",
}));
const getPaddingForKebab = (align) => align === "center" ? 2 * KEBAB_WITH_PADDING_WIDTH : KEBAB_WITH_PADDING_WIDTH;
export const StyledTableCellContentWithActionInner = styled(Flex).withConfig({ displayName: "StyledTableCellContentWithActionInner_APC-7311-productShell", componentId: "sc-zrg11v" })(({ column, isInGlobalFilters, theme }) => (Object.assign(Object.assign(Object.assign({ display: "block" }, (!hasTags(column) &&
    (column.width || column.maxWidth) && {
    maxWidth: `calc(100% - ${getPaddingForKebab(column.align)}px)`,
})), { overflow: "hidden", textOverflow: "ellipsis", marginRight: apolloSpaceInsetHalfX }), (isInGlobalFilters ? getIsInGlobalFiltersStyle(theme) : {}))));
//# sourceMappingURL=TableCell.style.js.map